import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, of, throwError } from 'rxjs';
import { Router } from '@angular/router';


@Injectable()
export class AppInterceptor implements HttpInterceptor {

  constructor(public router: Router,
    ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error) => {
        let handled: boolean = false;
        console.error(error);
        if (error instanceof HttpErrorResponse) {
          if (error.error instanceof ErrorEvent) {
            console.error("Error Event");
          } else {
            //console.log(`error status : ${error.status} ${error.statusText}`);
            switch (error.status) {
              case 401:      //login
              window.localStorage.removeItem('currentUser');
              window.localStorage.removeItem('token');
                this.router.navigateByUrl("/auth/login");
                //console.log(`redirect to login`);
                handled = true;
                break;
              case 403:     //forbidden
                this.router.navigateByUrl("/error/error-403");
                //console.log(`Access denied`);
                handled = true;
                break;
                case 404:     //not-found
                this.router.navigateByUrl("/error/error-404");
                //console.log(`Not Found`);
                handled = true;
                break;
            }
          }
        }
        else {
          console.error("Other Errors");
        }

        if (handled) {
          //console.log('return back ');
          return of(error);
        } else {
          //console.log('throw error back to to the subscriber');
          return throwError(error);
        }
      })
    )
  }
}
